import styled from "@emotion/styled";

const Backdrop = styled.div({
  width: "100%",
  height: "100%",
  position: "fixed",
  zIndex: 100,
  left: 0,
  top: 0,
  backgroundColor: "rgba(38, 50, 56, 0.7)",
});

export default Backdrop;
